<template>
  <div class="slide">
    <router-link tag='div' :to='{ "name": "home" }' class="a" :class="{ 'act': curs < 0 }"><span
        @click='setDateTime'>首页</span></router-link>
    <div v-for='(i, index) in slide' :key='index' class="a"
      :class="{ 'act': (curs == i.cur || cursQg(curs)[0] == cursQg(i.cur)[0]) && curs != '3-1', 'draplist': i.child }">
      <!-- v-if="$common.AUTH(i.key)" -->
      <span @click="FlinkTo(i)">{{ i.title }}</span>
      <div class="childList" v-if='i.child'>
        <a href='javascript:void(0)' v-if="$common.AUTH(j.key)" v-for='(j, ind) in i.child' :key="ind"
          @click="linkTo(j)" :class="{ 'cact': curs == j.cur }">{{ j.title }}</a>
      </div>
    </div>
    <!-- <router-link :to='{"name":"accountManage"}' v-if='$store.state.user.id==1' tag='div' class="a" :class="{'act':curs=='3-1'}">账户信息管理</router-link> -->
  </div>
</template>
<script>
import Slide from "./slide_n"
import User1 from "./user1"
import store from "../../store/index";
function putSlide(menu, userId) {
  const baseMenu = [{
    title: '法院目录',
    link: 'directoryManage',
    key: 'court:list',
    other: true,
    cur: '3-0',
  }]
  if (userId == 1) {
    menu[7].child = [...baseMenu, ...User1]
    return menu
  }
  else {
    menu[7].child = baseMenu
    return menu
  }

}
export default {
  props: {
    curs: {
      type: String,
      defalut: '0-0'
    }
  },
  data() {
    return {
      slide: putSlide(Slide, this.$store.state.user.id),
      ruleNode: [],
      allNode: false
    }
  },
  created() {
  },
  methods: {
    setDateTime() {
      store.dispatch("updateWatermarks");
    },
    cursQg(val) {
      if (val) {
        return val.split("-")
      }
    },
    getRuleNode() {
      if (this.$store.state.user) {
        let link_group = this.$store.state.user.link_group
        this.allNode = this.$store.state.user.link_group.filter((ele) => {
          return ele.user_group_id === 1
        }).length > 0  //是否有超级管理员权限
        if (!this.allNode) {
          let ruleNode = []
          link_group.forEach(ele => {
            ruleNode = ruleNode.concat(ele.group.view)
          });
          ruleNode = ruleNode.filter((ele, index) => {
            return ruleNode.indexOf(ele) === index;
          })
          this.ruleNode = ruleNode
        }
      }
    },
    FlinkTo(item) {
      const user = this.$store.state.user;
      if (user.id == 1) {
        this.linkTo(item)
      } else {
        if (item.child) {
          let Has = item.child
          // console.log(Has)
          if (!this.$common.AUTH(Has[0].key) && this.$store.state.user.id != 1 && Has[0].other) {
            this.$message.error("暂无权限")
            return false;
          }
          store.dispatch("updateWatermarks");
          if (Has[0].link != this.$route.name) {
            this.$router.push({ name: Has[0].link })
          } else {
            this.$router.go(0)
          }
        } else {
          this.linkTo(item)
        }
      }
    },
    linkTo(j) {
      if (!this.$common.AUTH(j.key) && this.$store.state.user.id != 1 && j.other) {
        this.$message.error("暂无权限")
        return false;
      }
      store.dispatch("updateWatermarks");
      if (j.link != this.$route.name) {
        this.$router.push({ name: j.link })
      } else {
        this.$router.go(0)
      }
    },
    isShow(item) {
      if (this.allNode) {
        return true
      } else {
        return this.ruleNode.filter((ele) => {
          return ele.split('-')[0] === item.key
        }).length > 0
      }
    }
  }
}
</script>
<style lang="less" scoped>
.slide {

  display: flex;

  .a {
    display: block;
    line-height: 22px;
    margin-left: 40px;
    font-size: 20px;
    color: rgba(255, 255, 255, 0.8);
    transition-duration: 500ms;
    padding-bottom: 12px;
    white-space: nowrap;
    position: relative;
    cursor: pointer;

    span {
      opacity: 0.8;
    }

    &::after {
      display: block;
      content: "";
      // position: absolute;
      // bottom: 20px;
      // left: 0;
      height: 2px;
      background: none;
      width: 30px;
      transition-duration: 500ms;
      border-radius: 3px;
      // left: 20%;
      margin:15px auto 0;
      // margin-left: -15px;
    }

    .childList {
      position: absolute;
      width: 96px;
      background: #fff;
      box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.2);
      left: -8px;
      top: 32px;
      transition-duration: 500ms;
      display: none;

      a {
        display: block;
        line-height: 20px;
        font-size: 14px;
        color: #333;
        text-align: center;
        transition-duration: 500ms;
        padding: 10px 0;

        &:hover {
          color: #1d8bfe;
        }

        &:nth-child(1) {
          padding-top: 14px;
        }

        &:nth-last-child(1) {
          padding-bottom: 14px;
        }
      }

      .cact {
        color: #1d8bfe;
      }
    }

    &:hover {
      color: rgba(255, 255, 255, 1);

      // &::after {
      //   background: #fff;
      // }
      span {
        opacity: 1;
      }

      .childList {
        display: block;
      }
    }
  }

  .draplist {
    background: url("../../assets/img/drap.png") no-repeat right 9px;
    background-size: 10px auto;
    padding-right: 14px;
  }

  .act {
    span {
      opacity: 1;
    }

    color: rgba(255, 255, 255, 1);

    &::after {
      background: #fff;
    }
  }
}
</style>
